import moment from "moment";
import CryptoJS from "crypto-js";
import { API_BASE_URL, HASHING_KEY } from "../config/Constant";

export const formatDate = (date) => {
  return moment(date).format("MMM Do YYYY, h:mm:ss A");
};

export const formatEmirateId = (number) => {
  const str = number.toString();
  const part1 = str.slice(0, 3);
  const part2 = str.slice(3, 7);
  const part3 = str.slice(7, 14);
  const part4 = str.slice(14, 15);
  return `${part1}-${part2}-${part3}-${part4}`;
};

const encryption = (value) => {
  const key = CryptoJS.enc.Utf8.parse(HASHING_KEY ?? API_BASE_URL ?? "");
  const encrypted = CryptoJS.AES.encrypt(value, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).ciphertext;
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted);
  return encryptedBase64;
};

const decryption = (value) => {
  const key = CryptoJS.enc.Utf8.parse(HASHING_KEY ?? API_BASE_URL ?? "");
  const decrypted = CryptoJS.AES.decrypt(value, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedText;
};

const setToLocalStorage = (key, value) => {
  const data = typeof value === "object" ? JSON.stringify(value) : value;
  const encryptedValue = encryption(data);
  localStorage.setItem(key, encryptedValue);
};

const getFromLocalStorage = (key) => {
  const encryptedValue = localStorage.getItem(key);
  if (encryptedValue) {
    const decryptedValue = decryption(encryptedValue);
    try {
      return JSON.parse(decryptedValue);
    } catch (e) {
      return decryptedValue;
    }
  }
  return null;
};

export { encryption, decryption, setToLocalStorage, getFromLocalStorage };
